(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const originalPositions = new WeakMap();
  let frameRequested = false;

  const productGridSelector =
    "main[data-template^='product'] .product-information > product-component.product-information__grid";

  const updateGrid = (grid) => {
    const media = grid.querySelector(':scope > .product-information__media');
    const details = grid.querySelector(':scope > .product-details');
    const movedHeader = grid.querySelector(':scope > .ary-mobile-product-header');

    if (mobileQuery.matches) {
      if (movedHeader || !media || !details) return;

      const detailsContent = details.querySelector(
        ':scope > .group-block > .group-block-content'
      );
      const header = detailsContent?.querySelector(':scope > .group-block');

      if (!header) return;

      originalPositions.set(header, {
        parent: header.parentNode,
        nextSibling: header.nextSibling,
      });

      header.classList.add('ary-mobile-product-header');
      grid.insertBefore(header, media);
      return;
    }

    if (!movedHeader) return;

    const original = originalPositions.get(movedHeader);
    movedHeader.classList.remove('ary-mobile-product-header');

    if (original?.parent?.isConnected) {
      const validNextSibling =
        original.nextSibling?.parentNode === original.parent ? original.nextSibling : null;
      original.parent.insertBefore(movedHeader, validNextSibling);
      return;
    }

    const detailsContent = details?.querySelector(
      ':scope > .group-block > .group-block-content'
    );
    if (detailsContent) detailsContent.appendChild(movedHeader);
  };

  const update = () => {
    document.querySelectorAll(productGridSelector).forEach(updateGrid);
  };

  const scheduleUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(() => {
      frameRequested = false;
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate, { once: true });
  } else {
    scheduleUpdate();
  }

  mobileQuery.addEventListener('change', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);

  new MutationObserver(scheduleUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
